import styled from '@emotion/styled';
import {t} from 'i18next';
import React from 'react';

import {showSimpleConfirmationDialog} from '_/sharedComponents/ConfirmationDialog';

export const showDeleteFolderDialog = (
  handleDeleteDecision: () => Promise<void>,
  deletionExtraInfo?: string
): void =>
  showSimpleConfirmationDialog({
    headerText: t('common:folders.delete.dialog.header').toString(),
    message: (
      <>
        <p>{t('common:folders.delete.dialog.description')}</p>
        {deletionExtraInfo ? (
          <StyledContainsOtherArtifactTypeInfo>
            {deletionExtraInfo}
          </StyledContainsOtherArtifactTypeInfo>
        ) : null}
      </>
    ),
    onConfirmed: handleDeleteDecision,
    buttonProps: {
      danger: true,
      confirmationButtonText: t('common:actions.delete').toString(),
    },
  });

const StyledContainsOtherArtifactTypeInfo = styled.p`
  font-weight: var(--font-weight-caution);
  margin-top: var(--gutter-little);
  color: var(--color-notification-important);
`;
